@if (allowToView()) {
  <lib-page-layout>
    <lib-title-navbar pageHeader title="Udostępniona gierka"></lib-title-navbar>

    <div>
      @if (gameDetails(); as game) {
        <div class="or-p-16-px or-mb-8-px">
          <lib-game-details
            [game]="game"
            [showHostInfo]="true"
            [showNavigateLink]="true"
            (onSendMessage)="sendMessage($event)"></lib-game-details>

          @if (allowToJoin(game.gameDateStart)) {
            <lib-join-buttons [game]="game" (applicationSent)="applicationSent($event)"></lib-join-buttons>
          }
        </div>
      }

      <div #map class="map-container-shared"></div>
    </div>
  </lib-page-layout>
} @else {
  @if (redirectPath(); as path) {
    <lib-blocked-web-view [path]="path"></lib-blocked-web-view>
  }
}
